import { IconTokens } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { api, StoreKey } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import sharedPropsService from "../../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { isFromAndroidWebview, nextStepCredStepper, showNewForeClosureFlow, showNewRepaymentFlowDc } from "../../../configs/utils";
import { REPAYMENT_COLLECTION_TYPE, UPDATE_REQUEST_TYPE } from "../../../configs/constants";
export var requestType;
(function (requestType) {
    requestType["ENHANCE"] = "ENHANCE";
    requestType["REVOCATION"] = "REVOCATION";
    requestType["RENEWAL_REQUEST"] = "RENEWAL_REQUEST";
    requestType["TRANSACTION_STATUS"] = "TRANSACTION_STATUS";
})(requestType || (requestType = {}));
export const navigate = async (action, _datastore, { navigate, navigateToBase, setDatastore }) => {
    console.warn("*** bottom nav action ***");
    if (action.payload.value === 1) {
        await navigateToBase(ROUTE.TRANSACTIONS, {
            isFromRejectedWithdrawal: false,
            isFromWithdrawalRejection: false
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawal: false,
            isFromWithdrawalRejection: false
        });
    }
    if (action.payload.value === 2) {
        await navigateToBase(ROUTE.MANAGE_LIMIT, {
            cacheManageLimitConfig: true,
            cacheCreditData: true,
            cachePendingCreditRequestByCreditId: true
        });
    }
    if (action.payload.value === 3) {
        await navigate(ROUTE.ALERT_PAGE, {
            alertProps: {
                type: "DEFAULT",
                iconName: IconTokens.Sound,
                title: "Coming soon",
                subTitle: "",
                ctaLabel: "Got It",
                ctaAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.DASHBOARD,
                    payload: {},
                },
            },
        });
    }
};
export const withdrawNow = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('WITHDRAW_BUTTON_CLICKED');
    await navigate(ROUTE.WITHDRAW_AMOUNT, {
        availableCreditAmount: action.payload.value,
    });
};
export const OpenProfile = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('USER_ACCOUNT_ICON_CLICKED');
    await navigate(ROUTE.MY_PROFILE);
};
export const OpenContactUS = async (action, _datastore, { navigate, instrumentTrack }) => {
    instrumentTrack('CONTACT_US_BUTTON_CLICKED');
    await navigate(ROUTE.CONTACT_US);
};
export const repayment = async (action, _datastore, { navigate, network, appendWidgets, instrumentTrack }) => {
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    const showNewRepaymentFlow = await showNewRepaymentFlowDc();
    if (showNewRepaymentFlow) {
        await navigate(ROUTE.PAYMENT_START);
    }
    else if (lenderId !== "Bajaj") {
        await navigate(ROUTE.PAYMENT_START);
    }
    else {
        await navigate(ROUTE.REPAYMENT, {
            repaymentAmount: action.payload.repaymentAmount,
        });
    }
};
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const learnMoreInterest = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.INTEREST_REPAYMENT_LEARN_MORE, { interestResponse: action.payload.interestReponse, type: action.payload.type, isFromTata: action.payload.isFromTata });
};
export const navToIC = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.INTEREST_CALCULATOR_APP, { isFromDashboard: true });
};
export const navigateToStatues = async (action, _datastore, { goBack, navigate }) => {
    console.warn("**** navigateToStatues Action Triggered ****", action);
    const renewalRequestDetailsList = action?.payload?.renewalRequestDetailsList;
    const user = await SharedPropsService.getUser();
    const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
    let result = { lenderAccountId: '', status: '', requestType: '' };
    result.lenderAccountId = lenderId;
    if (action.payload.type === requestType.RENEWAL_REQUEST) {
        await navigate(ROUTE.LOAN_RENEWAL_STATUS_PAGE, {
            renewalRequestDetailsList: renewalRequestDetailsList,
            routeId: ROUTE.DASHBOARD
        });
    }
    else if (action.payload.type === requestType.ENHANCE) {
        navigate(ROUTE.PRE_DASHBOARD_SCREEN);
    }
    else if (action.payload.type === requestType.TRANSACTION_STATUS) {
        navigate(ROUTE.TRANSACTIONS);
    }
    else if (action.payload.type === UPDATE_REQUEST_TYPE.EMAIL || action.payload.type === UPDATE_REQUEST_TYPE.PHONE_NUMBER) {
        await navigate(ROUTE.ACCOUNT_DETAILS);
    }
    else
        navigate(ROUTE.UNPLEDGE_STATUS, { target: action.payload.value });
};
export const learnMoreAction = async (action, _datastore, { goBack, navigate }) => {
    navigate(ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE, {});
};
export const renewNowAction = async (action, _datastore, { navigate }) => {
    console.warn('**** renewNowAction ACTION TRIGGERRED ****');
    const actualLoanAmount = action?.payload?.actualLoanAmount;
    const loanExpiryDays = action?.payload?.loanExpiryDays;
    const isLoanExpired = action?.payload?.isLoanExpired;
    if (isLoanExpired === true) {
        await sharedPropsService.setIsRenewalAfterExpiry(true);
    }
    await navigate(ROUTE.LOAN_RENEWAL_LANDING_PAGE, {
        actualLoanAmount: actualLoanAmount,
        loanExpiryDays: loanExpiryDays
    });
};
export const loanRenewalExpiredRepayment = async (action, _datastore, { navigateWithClear, navigate }) => {
    console.warn('**** loanRenewalExpiredRepayment ACTION TRIGGERRED ****');
    await sharedPropsService.setIsRepaymentAfterExpiry(true);
    await navigateWithClear(ROUTE.PAYMENT_START);
};
export const loanRefundAction = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.FORECLOSURE);
};
export const navigateToInterestRepaymentDetials = async (action, _datastore, { navigateWithClear }) => {
    //set the flag to true
    console.warn("INTEREST REPAYMENT DETAILS", action.payload.type, action.payload.interestResponse);
    await navigateWithClear(ROUTE.INTEREST_REPAYMENT_DETAILS, { interestResponse: action.payload.interestReponse, type: action.payload.type });
};
export const reOpenLoanAccount = async (action, _datastore, { navigateWithClear, network }) => {
    console.warn('**** loanRenewalExpiredRepayment ACTION TRIGGERRED ****');
    //set the flag to true
    const user = await sharedPropsService.getUser();
    const creditId = user?.linkedCredits[0]?.creditId;
    const reopenAccountResponse = await network.post(`${api.reopenAccount}${creditId}`, {}, {
        headers: await getAppHeader()
    });
    if (reopenAccountResponse?.status === 200) {
        await AsyncStorage.removeItem(StoreKey.APPLICATION_ID);
        await navigateWithClear(ROUTE.SPLASH_SCREEN);
    }
};
export const needHelpAction = async (action, _datastore, { navigate, network }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const navigateToShortfallDetails = async (action, _datastore, { navigateWithClear }) => {
    const shortfallDetails = action?.payload?.shortfallDetails;
    const availableCreditAmount = action?.payload?.availableCreditAmount;
    await navigateWithClear(ROUTE.SHORTFALL_DETAILS_SCREEN, {
        shortfallDetails,
        availableCreditAmount,
    });
};
export const navigateToAccountDetails = async (action, _datastore, { navigate }) => {
    const profileDetails = action?.payload?.value;
    await navigate(ROUTE.ACCOUNT_DETAILS, {
        //@ts-ignore
        profileData: profileDetails,
    });
};
export const navigateToTransactionHistory = async (action, _datastore, { navigate, setDatastore }) => {
    await navigate(ROUTE.TRANSACTIONS, {
        isFromRejectedWithdrawal: false,
        isFromWithdrawalRejection: false
    });
    await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
        isFromRejectedWithdrawal: false,
        isFromWithdrawalRejection: false
    });
};
export const navigateToManageLimit = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.MANAGE_LIMIT);
};
export const navigateTrackLoanClosure = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.FORECLOSURE);
};
export const navigateToTransactionsPostRejectionAction = async (action, _datastore, { navigate, setDatastore }) => {
    const data = action?.payload?.data;
    const type = action?.payload?.type;
    if (type === "Repayment") {
        await navigate(ROUTE.TRANSACTIONS, {
            withdrawalRejectedData: data,
            isFromRejectedWithdrawal: false,
            isFromRejectedRepayment: true
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedWithdrawal: false,
        });
    }
    else {
        await navigate(ROUTE.TRANSACTIONS, {
            withdrawalRejectedData: data,
            isFromRejectedRepayment: false,
            isFromRejectedWithdrawal: true,
        });
        await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
            isFromRejectedRepayment: false,
        });
    }
};
export const navigateToWithdrawalScreenAction = async (action, _datastore, { navigate, setDatastore }) => {
    const amount = action?.payload?.amount;
    const availableCreditLimit = action?.payload?.availableCreditLimit;
    const type = action?.payload?.type;
    const collectionType = action?.payload?.collectionType;
    const interestResponse = action?.payload?.interestReponse;
    const interestRepaymentType = action?.payload?.interestRepaymentType;
    const shortfallDetails = action?.payload?.shortfallDetails;
    const availableCreditAmount = action?.payload?.availableCreditAmount;
    if (type === "WITHDRAWAL_FAILED") {
        await navigate(ROUTE.WITHDRAW_AMOUNT, {
            withdrawalAmount: amount,
            availableCreditAmount: availableCreditLimit
        });
    }
    else if (collectionType === REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION) {
        await navigate(ROUTE.INTEREST_REPAYMENT_DETAILS, {
            interestResponse: interestResponse,
            type: interestRepaymentType
        });
    }
    else if (collectionType === REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT) {
        await navigate(ROUTE.SHORTFALL_DETAILS_SCREEN, {
            shortfallDetails,
            availableCreditAmount
        });
    }
    else if (collectionType === REPAYMENT_COLLECTION_TYPE.FORECLOSURE) {
        const showNewForeclosure = await showNewForeClosureFlow();
        if (showNewForeclosure) {
            await navigate(ROUTE.FORECLOSURE_NEW);
        }
        else
            await navigate(ROUTE.FORECLOSURE);
    }
    else {
        await navigate(ROUTE.PAYMENT_START, {
            isFromDashboard: true,
            amount: amount,
            collectionType: collectionType
        });
    }
    await setDatastore(ROUTE.TRANSACTIONS, "TransactionScreen", {
        isFromRejectedWithdrawal: false,
    });
};
export const sdkProcessCompleteCardClose = async (action, _datastore, { setDatastore }) => {
    await AsyncStorage.setItem("showProcessCompletedCard", "true");
};
export const backAction = async (action, _datastore, { setDatastore }) => {
    console.warn("BACK BUTTON CLICKED");
    window?.parent?.postMessage("Exit callback", "*");
    if (isFromAndroidWebview()) {
        window.open("closeActivity", "_parent");
    }
    // @ts-ignore
    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
};
export const onWithdrawClickAction = async (action, _datastore, { setDatastore, navigate }) => {
    const availableCreditAmount = action?.payload?.availableCreditAmount;
    await setDatastore(ROUTE.DASHBOARD, "sdkProcessCompletedCard", {
        visible: false
    });
    await AsyncStorage.setItem("showProcessCompletedCard", "true");
    await navigate(ROUTE.WITHDRAW_AMOUNT, {
        availableCreditAmount: availableCreditAmount
    });
};
export const clearDues = async (action, _datastore, { setDatastore, navigate }) => {
    await navigate(ROUTE.PAYMENT_START);
};
export const cancelAccountClosure = async (action, _datastore, { setDatastore, navigateWithClear, network, instrumentTrack }) => {
    await instrumentTrack('ACCOUNT_CLOSURE_CANCEL_CONFIRMATION_BUTTON_CLICKED');
    const user = await SharedPropsService.getUser();
    const creditId = user?.linkedCredits[0].creditId;
    const response = await network.post(`${api.cancelForeclosure}/${creditId}`, {}, {
        headers: await getAppHeader(),
    });
    if (response?.status === 200) {
        await navigateWithClear(ROUTE.DASHBOARD);
    }
    else {
    }
};
export const cancelAccount = async (action, _datastore, { setDatastore, navigateWithClear, network, instrumentTrack }) => {
    await instrumentTrack('ACCOUNT_CLOSURE_CANCEL_BUTTON_CLICKED');
};
export const navigateToElevate = async (action, _datastore, { instrumentTrack, navigate }) => {
    SharedPropsService.setElevateFlow(true);
    await instrumentTrack('ELEVATE_HOME_CARD_CLICKED');
    await navigate(ROUTE.ELEVATE_LANDING);
};
export const continueElevate = async (action, _datastore, { instrumentTrack, navigateWithClear }) => {
    await instrumentTrack('ELEVATE_CONTINUE_CLICKED');
    SharedPropsService.setElevateFlow(true);
    await AsyncStorage.setItem('application_id', action?.payload?.applicationId);
    const routeObj = await nextStepCredStepper(action?.payload?.currentStepId, action?.payload?.stepStatusMap);
    await navigateWithClear(routeObj.routeId, routeObj.params);
};
export const switchAccount = async (action, _datastore, { instrumentTrack, navigateWithClear }) => {
    const targetCreditId = action?.payload?.targetCreditId;
    await instrumentTrack('ELEVATE_SWITCH_CLICKED');
    await navigateWithClear(ROUTE.ELEVATE_SWITCHING, {
        targetCreditId: targetCreditId
    });
};
